export default "__VITE_PUBLIC_ASSET__4068bac3__"